export class BocciaturaConsegnaFase3 {
    

    retOK!:boolean;
    psiOK!:boolean;
    subiruOK!:boolean;
    nt9OK!:boolean;

    noteRET!:string;
    notePSI!:string;
    noteSUBIRU!:string;
    noteNT9!:string;


    problemiRET!:string[];
    problemiPSI!:string[];
    problemiNT9!:string[];
    problemiSUBIRU!:string[];
    
  }
  